/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React from 'react';
// components
import { Message  } from '@design-system-coopeuch/web';
import CardVoucherTwo from './Voucher2';
import CardPasswordAndDigitize from './CardPasswordAndDigitize';
import CardNextSteps from './CardNextSteps';
import FlowControlButtons from '../../molecules/FlowControlButtons/FlowControlButtons';
import Modal from '../../organisms/Modal/Modal';
import Survey from '../../../containers/Survey/Survey';
// assets
import { StyledWrapperCards } from './styles';

const SummaryTemplate = (props) => {
  const {
    email,
    amountMonthlyFees,
    transactionDateTimeLong,
    detailData,
    isMobileDevice,
    monthlyFees,
    isOpenModalVoucherDetail,
    openModalVoucherDetail,
    closeModalVoucherDetail,
    isOpenModalUsabilityAndSatisfactionSurvey,
    closeModalUsabilityAndSatisfactionSurvey,
    onDownloadComponentPdf,
    onReturnMainPage,
    onCallSurvey,
    phone,
    password,
    confirmationPassword,
    inputCodeSMS,
    stateAuthSms,
    stateCreatingPassword,
    canValidateOtp,
    canCreatePassword,
    passwordVisibility,
    confirmationPasswordVisibility,
    messagesInputAuthSms,
    onInvokeAuthSms,
    onChangeEletronicSignature,
    onTimeOverToRespond,
    onChangePasswordVisibility,
    onValidateOtp,
    onCreatePassword,
    storeSelected,
    onChangeStoreSelected,
    isOpenCurrentModal,
    nameCurrentModal,
    onCloseCurrentModal,
    onOpenCurrentModal,
    onRedirectToPrivateSite,
  } = props;

  return (
    <>
      <StyledWrapperCards>
        <Message
          className="w-100"
          type="success"
          description={
            <p>
              <span className="font-weight-bold">¡Felicitaciones!</span> Ya eres Socio Coopeuch, disfruta los beneficios.
            </p>
          }
          closer={null}
        />
        
        <CardVoucherTwo 
         email={email}
         monthlyFees={monthlyFees}
         amountMonthlyFees={amountMonthlyFees}
         transactionDateTimeLong={transactionDateTimeLong}
         detailData={detailData}
         isOpenModalVoucherDetail={isOpenModalVoucherDetail}
         closeModalVoucherDetail={closeModalVoucherDetail}
         openModalVoucherDetail={openModalVoucherDetail}
         isMobileDevice={isMobileDevice}
         onDownloadComponentPdf={onDownloadComponentPdf}
         onCallSurvey={onCallSurvey}
        />


        <CardPasswordAndDigitize
          phone={phone}
          password={password}
          confirmationPassword={confirmationPassword}
          inputCodeSMS={inputCodeSMS}
          stateAuthSms={stateAuthSms}
          stateCreatingPassword={stateCreatingPassword}
          passwordVisibility={passwordVisibility}
          confirmationPasswordVisibility={confirmationPasswordVisibility}
          canValidateOtp={canValidateOtp}
          canCreatePassword={canCreatePassword}
          messagesInputAuthSms={messagesInputAuthSms}
          storeSelected={storeSelected}
          onInvokeAuthSms={onInvokeAuthSms}
          onChange={onChangeEletronicSignature}
          onTimeOverToRespond={onTimeOverToRespond}
          onValidateOtp={onValidateOtp}
          onCreatePassword={onCreatePassword}
          onChangeStoreSelected={onChangeStoreSelected}
          onChangePasswordVisibility={onChangePasswordVisibility}
          isOpenCurrentModal={isOpenCurrentModal}
          nameCurrentModal={nameCurrentModal}
          onCloseCurrentModal={onCloseCurrentModal}
          onOpenCurrentModal={onOpenCurrentModal}
          onRedirectToPrivateSite={onRedirectToPrivateSite}
        />
        <CardNextSteps
          email={email}
          isMobileDevice={isMobileDevice}
          onDownloadComponentPdf={onDownloadComponentPdf}
          detailData={detailData}
        />
        <FlowControlButtons
          step="end"
          onReturnMainPage={onReturnMainPage}
          onCallSurvey={onCallSurvey}
        />
      </StyledWrapperCards>
     
      <Modal
        isOpen={isOpenModalUsabilityAndSatisfactionSurvey}
        closeModal={closeModalUsabilityAndSatisfactionSurvey}
      >
        <Survey type="usabilityAndSatisfaction" />
      </Modal>
    </>
  );
};

export default SummaryTemplate;
